import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { activateAccount, amplitude } from 'wisestep-api';
import { WsButton, WsTypography, Item, WsTypoVariants, WisestepLogo } from 'wisestep-base';

import { AuthLayout } from '../../../components';

const StyledGrid = styled(Grid)(() => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  rowGap: 16,
}));

const AccountActivation = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [checkDone, setCheckDone] = useState(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  useEffect(() => {
    if (!checkDone) {
      (async () => {
        try {
          await activateAccount(params.get('key') ?? '');
          amplitude('Signup Success', {
            clickedOn: 'Signup_Success',
            pageName: 'Signup',
            pageUrl: window.location.href,
            interfaceType: 'Web',
          });
          setIsSuccess(true);
          setCheckDone(true);
        } catch (error) {
          setIsSuccess(false);
          setCheckDone(true);
        }
      })();
    }
  }, [checkDone, params]);
  return (
    <AuthLayout>
      <Item>
        <Grid container spacing={4} display="flex" justifyContent="center">
          <StyledGrid item container xs={12}>
            <WisestepLogo />
          </StyledGrid>
          {checkDone && (
            <>
              {isSuccess ? (
                <StyledGrid item container xs={12}>
                  <WsTypography variant={WsTypoVariants.TITLE}>
                    Thank you for confirming your email.
                  </WsTypography>
                  <WsTypography variant={WsTypoVariants.TITLE}>
                    Your account is created successfully on Wisestep.
                  </WsTypography>
                  <WsTypography variant={WsTypoVariants.TITLE}>
                    Please login to continue.
                  </WsTypography>
                </StyledGrid>
              ) : (
                <StyledGrid item xs={12} container>
                  <WsTypography variant={WsTypoVariants.TITLE}>Invalid Link.</WsTypography>
                  <WsTypography variant={WsTypoVariants.TITLE}>
                    Your account is already activated.
                  </WsTypography>
                  <WsTypography variant={WsTypoVariants.TITLE}>
                    Please login to continue.
                  </WsTypography>
                </StyledGrid>
              )}
            </>
          )}

          <Grid item xs={6} display="flex" justifyContent="center">
            <WsButton fullWidth type="button" variant="contained" onClick={() => navigate('/')}>
              Sign In
            </WsButton>
          </Grid>
        </Grid>
      </Item>
    </AuthLayout>
  );
};

export default AccountActivation;
